<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-verify-code"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="verify_modal_image">
                        <img :src="campaign.fullImageUrl" alt="">
                    </div>
                </div>
                <div class="modal-base-body">
                    <div id="verify_modal_title">{{title}}</div>
                    <div id="verify_modal_msg" v-html="getPointMessage()"></div>
                    <div>
                        <div class="verify-code-label">กรุณาระบุรหัส</div>
                        <TextInput
                            v-model="lblInputCode"
                            :errorInfo="errorInfo[0]"
                            addClass="verify-code-input"
                            inputId="verify_code"
                            :inputLbl="fromLbl"
                            :maxLength="12"
                            :isShowError="isShowError"
                            :isSubmitted="isSubmitted"
                            :isHideLabel="false"
                            :iconClear="true"
                            @update:inputValue="updateInput()" />
                    </div>
                </div>
                <div class="modal-base-footer modal-footer-btn-row">
                    <div class="btn-wrapper btn-cancel" @click="clickCancel()"> 
                        <div class="btn-txt">ปิด</div>  
                    </div>
                    <div class="btn-wrapper" @click="clickOk()">
                        <div class="btn-txt">ตกลง</div>      
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// helper
import FormHelper from '@/helper/FormHelper.js';
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//components
import TextInput from '@/components/Input/Text.vue';

/**
 * @property {VerifyCodeModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "VerifyCodeModal",
    props: {
        // busModal: Object,
        theme: String,
        controller: Object,
        modalId: String,
    },
    components: {
        TextInput,
    },
    data: function() {
        return {
            campaign: {},
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            busModal: null,
            lbl: Locale.getLbl(),

            lblInputCode: '',
            fromLbl: {},
            errorInfo: [],
            isVerifyCode: null,
            isSubmitted: false,
            isShowError: true,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;

        this.errorInfo = FormHelper.genErrorInfo(1);
        let lbl = {
            name: '',
            placeholder: 'กรุณาระบุรหัส',
            required: '',
            too_short: '',
            invalid: 'คุณกรอกรหัสไม่ถูกต้อง',
        };
        this.fromLbl = lbl;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
        this.busModal.$on('showError', this.showError);
    },
    methods: {
        clickOk: async function () {
            if (this.lblInputCode == '') return;
            this.isSubmitted = true;
            this.isVerifyCode = this.lblInputCode;

            if (this.isVerifyCode) {
                this.hide();
                this.controller.sendCallbackOk(this.isVerifyCode);
            } else {
                this.isShowError = true;
                this.formErrorInfo[0].isValid = false
            }
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
            this.lblInputCode = '';
            window.location.reload()
        },
        updateInput: function() {
            this.isSubmitted = false;
            this.formErrorInfo[0].isValid = true
            this.isShowError = false;
        },
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return `<div class="text-point">${pointType} <span class="points">${Util.formatNum(this.campaign.pointPerUnit)}</span> ${pointUnit}</div>`;
        },
        show: function(config) {
            this.campaign = config.campaign;
            this.title = this.campaign.name;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        showError: function (error) {
            if(error.id == 404) {
                this.fromLbl.invalid = 'คุณกรอกรหัสไม่ถูกต้อง';
            } else if (error.id == 2021) {
                this.fromLbl.invalid = 'คุณกรอกรหัสที่เคยใช้แล้ว/หมดอายุ';
            }
            this.$bvModal.show(this.modalId);
        }
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-verify-code {
        @extend %modal-base;

        .modal-dialog {
            max-width: 360px;
        }

        .modal-base-head {
            margin-bottom: 20px;
            
            .verify_modal_image {
                @include baseCampaignImg(100%);
                border-radius: 10px;
                width: 120px;
                margin-top: -70px;
                margin-left: auto;
                margin-right: auto;
            }
        }

        .modal-base-body {
            
            #verify_modal_title {
                font-size: 1.5rem;
                font-family: $semi_bold;
                text-align: left;
                color: $a-gray-333333;
            }

            #verify_modal_msg {
                margin-bottom: 42px;
                font-size: 1.5rem;
                font-family: $regular;
                color: $a-gray-575757;
                line-height: normal;

                .text-point {
                    font-size: 1.5rem;
                    font-weight: normal;
                    color: $a-gray-575757;

                    .points {
                        color: $green-00987F;
                        font-family: $semi_bold;
                    }
                }
            }

            .verify-code-label {
                font-size: 1.75rem;
                font-family: $semi_bold;
                text-align: center;
                color: $a-gray-575757;
            }

            .verify-code-input { 
                @include baseInput();
                margin: 20px 0 16px 0;
                position: relative;

                .input-wrapper {
                    input {
                        padding-right: 50px;
                    }
                }

                .icon-clear{
                    position: absolute;
                    right: 16px;
                    top: 16px;
                    bottom: 0;
                    margin: auto;
                    height: 50px;
                }
                
                .input-error-txt {
                    text-align: left;
                    color: $a-red-C03744;
                }

                &.input-error .input-wrapper input{
                    border-color: $a-gray-C4C4C4;
                }
            }
        }
    }
</style>
